import type { CheckoutRuntimeConfig } from '../theme/types';

/**
 * REAL GAP FOUND AND FIXED: this was built against an ASSUMED route/shape
 * (`GET {baseUrl}/v1/tenants/{clientSlug}/refund-policy` -> `{ text: string | null }`) before the
 * backend's real refund-policy-read endpoint existed. Confirmed live (every page load 404'd):
 * the real route is `GET {baseUrl}/v1/refund-policy` - tenant comes from the request's own
 * Authorization/Host resolution (same as every other public route on this Worker), never a path
 * param - and the real response shape is `{ refundPolicy: { policyType, daysBeforeEvent?,
 * policyText } | null }` (`packages/db/src/schema/tenants.ts`'s `RefundPolicy`), not `{ text }`.
 *
 * This is still a non-critical, display-only read - any failure (network, 404, unexpected shape)
 * must never block or error out the checkout flow, so every failure path resolves to `null`.
 */
export async function fetchRefundPolicy(
  config: CheckoutRuntimeConfig,
  signal?: AbortSignal,
): Promise<string | null> {
  try {
    const res = await fetch(`${config.baseUrl.replace(/\/+$/, '')}/v1/refund-policy`, {
      headers: { Accept: 'application/json', Authorization: `Bearer ${config.publicKey}` },
      signal,
    });
    if (!res.ok) return null;
    const json = (await res.json().catch(() => null)) as {
      refundPolicy?: { policyText?: string | null } | null;
    } | null;
    const text = json?.refundPolicy?.policyText;
    return typeof text === 'string' && text.trim() ? text : null;
  } catch {
    return null;
  }
}
